import React from 'react';
import CSS from './styles.css';

const PageSelectorViews = props => {
  const isPlaceholder = !props.inputValue
  let inputBox;
  if (props.pageBreakError) {
    inputBox = CSS['page__input--error']
  } else if (isPlaceholder) {
    inputBox = CSS['page__input_placeholder'];
  } else {
    inputBox = CSS['page__input'];
  }
  const arrowStyle = props.isMobile ? CSS['arrow-up'] : CSS['arrow-left'];
  const errorTextStyle = props.isMobile ? CSS['tooltiptext-up'] : CSS['tooltiptext'];
  return (
    <div className={CSS['tooltip']}>
      <input 
        onKeyDown={ props.goToPage }
        onFocus={ props.handleInputFocus }
        onBlur={ props.handleInputBlur }
        value={ props.inputValue }
        className={ inputBox }
        onChange={ props.handlePageInputChange }
        htmlFor="pageNumberInput"
        aria-label="page number input"
        aria-describedby="pageNumberErrorMessage"
      />
      { props.pageBreakError &&
        <div>
          <div 
            className={ arrowStyle }
          />
          <span
            id="pageNumberErrorMessage"
            className={ errorTextStyle }
            aria-label="page number input error message"
          >
            {props.pageBreakError}
          </span>
        </div>
      }
    </div>
  );
}

export default PageSelectorViews;